import { render, staticRenderFns } from "./CookieBar.vue?vue&type=template&id=cb92f282&"
import script from "./CookieBar.vue?vue&type=script&lang=js&"
export * from "./CookieBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Projekte/woerner-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb92f282')) {
      api.createRecord('cb92f282', component.options)
    } else {
      api.reload('cb92f282', component.options)
    }
    module.hot.accept("./CookieBar.vue?vue&type=template&id=cb92f282&", function () {
      api.rerender('cb92f282', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/pageDesign/CookieBar.vue"
export default component.exports